import React, { useState, useEffect, useContext } from "react";
import Head from "next/head";

import { Box, Heading } from "@chakra-ui/core";

import AuthEmail from "components/auth/AuthEmail";

import useAuth from "context/Auth";
import { useRouter } from "next/router";
import { fuego } from "@nandorojo/swr-firestore";
import { ContextStore } from "context/ContextStore";

const Connexion = () => {
  const { user, loading, isAuthenticated } = useAuth();

  const router = useRouter();
  const { showToast, handleError } = useContext(ContextStore);

  const [hasRunOnce, setHasRunOnce] = useState(false);
  // Redirects to /admin on page load if admin is already logged in
  useEffect(() => {
    if (!hasRunOnce && !loading) {
      setHasRunOnce(true);
      if (user) {
        fuego
          .auth()
          .currentUser?.getIdTokenResult()
          .then((idTokenResult) => {
            // Confirm the user is an Admin.
            if (!!idTokenResult.claims.administrator) {
              router.push("/admin"); // Redirect
            } else if (user.phoneNumber !== null) {
              showToast({
                title: "Vous êtes déjà connecté",
              });
              router.push("/compte/commandes");
            }
          })
          .catch((error) => {
            handleError({ error });
          });
      }
    }
  }, [user, loading]);

  return (
    <>
      <Head>
        <title>Connexion | La Citadelle</title>
      </Head>
      <Box bg="gray.50">
        <Box maxW="3xl" mx="auto" py="12" px="4" overflow="hidden">
          <Box>
            <Heading mb="6" textAlign="center">
              Connexion
            </Heading>
            <Box mb="6" minH="414px">
              <AuthEmail />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Connexion;
